import * as actions from '../actions/types'

const initialState = {
  colleges: []
};

function updateEducationInfo(educationState, action){
  return {
    ...educationState,
    ...action.updates
  };
}

function setEducationInfo(educationState, action){
  return {
    ...action.application.education
  }
}

function addCollege(educationState, action){
  return {
    ...educationState,
    colleges: [...educationState.colleges, action.newCollege]
  };
}

function removeCollege(educationState, action){
  return {
    ...educationState,
    colleges: educationState.colleges.filter(college => action.collegeId !== college.id)
  };
}

function updateCollege(educationState, action){
  return {
    ...educationState,
    colleges: educationState.colleges.map((college) => {
      if(action.collegeId !== college.id)
        return { ...college };
      return {
        ...college,
        ...action.updates
      };
    })
  };
}

function addCourse(educationState, action){
  return {
    ...educationState,
    colleges: educationState.colleges.map((college) => {
      if(action.collegeId !== college.id)
        return { ...college };
      return {
        ...college,
        courses: [...college.courses, action.newCourse]
      };
    })
  };
}

function removeCourse(educationState, action){
  return {
    ...educationState,
    colleges: educationState.colleges.map((college) => {
      if(action.collegeId !== college.id)
        return { ...college };
      return {
        ...college,
        courses: college.courses.filter(course => action.courseId !== course.id)
      };
    })
  };
}

function updateCourse(educationState, action){
  return {
    ...educationState,
    colleges: educationState.colleges.map((college) => {
      if(action.collegeId !== college.id)
        return { ...college };
      return {
        ...college,
        courses: college.courses.map((course) => {
          if(action.courseId !== course.id)
            return course;
          return {
            ...course,
            ...action.updates
          }
        })
      };
    })
  };
}

function applicationDeleted() {
  return initialState;
}

export const educationInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_APPLICATION:
    case actions.REFRESH_APPLICATION:
      return setEducationInfo(state, action);
    case actions.UPDATE_EDUCATION_INFO: return updateEducationInfo(state, action);
    case actions.ADD_COLLEGE: return addCollege(state, action);
    case actions.REMOVE_COLLEGE: return removeCollege(state, action);
    case actions.UPDATE_COLLEGE: return updateCollege(state, action);
    case actions.ADD_COURSE: return addCourse(state, action);
    case actions.REMOVE_COURSE: return removeCourse(state, action);
    case actions.UPDATE_COURSE: return updateCourse(state, action);
    case actions.DELETE_APPLICATION_SUCCESS: return applicationDeleted(state, action);
    default: return state;
  }
};

export default educationInfoReducer;